<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Credit Safecheck History For Client {{clientNo}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  
  <div *ngIf="historyData.length == 0" class="alert alert-info">
    No Changes
  </div>

  <div *ngIf="historyData.length > 0" class="table-responsive" style="max-height: 70vh; overflow-y: auto;">
    <table mat-table [dataSource]="historyData">
      
      <ng-container matColumnDef="faStatus">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item">
          <fa-icon *ngIf="item.creditCheckStatus == 'Error' || item.creditCheckStatus == 'Fail'"
                   [icon]="faExclamationCircle"
                   size="1x"
                   class="text-danger"></fa-icon>
          <fa-icon *ngIf="item.creditCheckStatus == 'Success'"
                   [icon]="faCheckCircle"
                   size="1x"
                   class="text-success"></fa-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="checkPerformedDate">
        <mat-header-cell *matHeaderCellDef>Date Check Performed.</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.checkPerformedDate | date: 'dd/MM/yyyy HH:mm'}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="checkPerformedBy">
        <mat-header-cell *matHeaderCellDef>Check Performed By.</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.checkPerformedByUser.fullName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="checkResult">
        <mat-header-cell *matHeaderCellDef>Result.</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.creditCheckStatus}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="isManual">
        <mat-header-cell *matHeaderCellDef>Manual Check.</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.isManualCheck ? "Yes" : "No"}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="checkResultString">
        <mat-header-cell *matHeaderCellDef>Result String.</mat-header-cell>
        <mat-cell *matCellDef="let item">{{item.checkResultString}}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
      <mat-row *matRowDef="let item; columns: displayedColumns;"></mat-row>

    </table>
  </div>

</div>